module.exports = __webpack_public_path__ + "static/media/link.0d78095e.png";